<template>
<div id="product-features-bar" class="bar_graph">
  <dl>
    <dt>
      Product features
    </dt>
    <dd v-for="product in products" v-bind:key="product.name" v-bind:class="'percentage percentage-' + product.percentage">
      <span class="text">{{ product.name }}<span>{{ product.count }} ({{ product.percentage }}%)</span></span>
    </dd>
  </dl>
</div>
</template>

<script>
export default {
  name: 'ProductsBar',
  computed: {
    products () {
      return this.$store.getters.productsBar
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bar_productfeatures.vue